export default __webpack_public_path__ + "f8761a1b4e54a86d536ffc13b4135b36.png";